import { useState } from 'react';
import Equal from 'customer-data-filters-ui/filterQueryFormat/operator/Equal';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { FormControl } from 'foundations-components/transitional/components/FormControl';
import { TextInput } from 'foundations-components/transitional/components/TextInput';
import QuickFilterSelect from './QuickFilterSelect';
import QuickFiltersTags from '../QuickFiltersTags';
import { View } from 'foundations-components/components/View';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const getValuesFromCondition = condition => {
  if (!condition || !condition.value) {
    return [];
  }
  return condition.value.toJS();
};
const StringQuickFilter = ({
  buttonProperties,
  condition,
  disableTruncation,
  isFirst,
  property,
  onValueChange
}) => {
  const values = getValuesFromCondition(condition);
  const [textInput, setTextInput] = useState('');
  const [isOpen, setIsOpen] = useState(false);
  const onAddValue = newValue => {
    if (newValue && !values.includes(newValue)) {
      onValueChange(Equal.of(property, [...values, newValue].join(' OR ')));
      setTextInput('');
    }
  };
  const onRemoveValue = valueToDelete => {
    const newValues = values.filter(value => value !== valueToDelete);
    if (newValues.length) {
      onValueChange(Equal.of(property, newValues.join(' OR ')));
    } else {
      onValueChange();
    }
  };
  const onTextInputChange = evt => {
    setTextInput(evt.target.value);
  };
  const onTextInputKeyDown = evt => {
    if (evt.key === 'Enter') {
      onAddValue(textInput);
    }
  };
  const tags = values.map(value => {
    return {
      value,
      label: value
    };
  });
  const onToggleOpen = () => {
    setIsOpen(currentIsOpen => !currentIsOpen);
  };
  return /*#__PURE__*/_jsx(QuickFilterSelect, {
    property: property,
    buttonProperties: buttonProperties,
    buttonText: property.displayName,
    condition: condition,
    disableTruncation: disableTruncation,
    isActive: !!values.length,
    isFirst: isFirst,
    isOpen: isOpen,
    popoverContent: /*#__PURE__*/_jsxs(View, {
      as: "div",
      marginInline: "500",
      marginBlockStart: "200",
      marginBlockEnd: "500",
      inlineSize: "300px",
      children: [/*#__PURE__*/_jsx(FormControl, {
        label: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "customerDataFiltersUI.quickFiltersBar.string.label"
        }),
        marginBlockEnd: "300",
        children: /*#__PURE__*/_jsx(TextInput, {
          value: textInput,
          onChange: onTextInputChange,
          onKeyDown: onTextInputKeyDown
        })
      }), /*#__PURE__*/_jsx(QuickFiltersTags, {
        tags: tags,
        onTagClose: onRemoveValue
      })]
    }),
    onToggleOpen: onToggleOpen,
    onValueChange: onValueChange
  });
};
export default StringQuickFilter;